﻿import { Component, OnInit } from '@angular/core';

import { RestService } from 'src/app/_services/rest.service';
import { Router } from '@angular/router';

@Component({ templateUrl: 'users.component.html' })
export class UsersComponent implements OnInit {

    users: any;

    constructor(private restService: RestService, private router: Router) {
    }

    ngOnInit() {
        this.loadAllUsers();
    }



    edit(userId: string) {
        this.router.navigate(['/root/users/' + userId]);
    }

    private loadAllUsers() {
        this.restService.getAll('/rest-api/root/user').subscribe(data => {
            this.users = data;
        });
    }
}
